<span class="description">
  <span class="name">
    {{ recipe.name }}
  </span>

  @if (settings.showPrices && recipe.displayFoodPortalPrice && recipe.foodPortalPrice) {
    <span class="price">
      {{ recipe.foodPortalPrice | currency: "GBP" }}
    </span>
  }

  @if (recipe.description && settings.showRecipeDescriptions) {
    <span class="recipe-description">
      {{ recipe.description }}
    </span>
  }

  @if (showContainsAllergenWarning(recipe)) {
    <span class="allergen-warning">
      <span class="icon-exclamation-circle"></span>
      <span>Contains allergens</span>
    </span>
  }

  @if (showMissingAllergensWarning(recipe)) {
    <span class="allergen-warning">
      <span class="icon-exclamation-circle"></span>
      <span>Missing allergens</span>
    </span>
  }

  <span class="diet-types">
    @if (recipe.isVegetarian) {
      <span class="icon-diet-vegetarian" title="Vegetarian"></span>
    }
    @if (recipe.isVegan) {
      <span class="icon-diet-vegan" title="Vegan"></span>
    }
    @if (recipe.isHalal) {
      <span class="icon-halal" title="Halal"></span>
    }
    @if (recipe.isKosher) {
      <span class="icon-kosher" title="Kosher"></span>
    }
    @if (recipe.isGlutenFree) {
      <span class="icon-gluten-free" title="Gluten-free"></span>
    }
  </span>

  @if (!!recipe.tagIds.length) {
    <span class="tags">
      @for (tagId of recipe.tagIds; track tagId) {
        <span class="tag">
          {{ tagName(tagId) }}
        </span>
      }
    </span>
  }
</span>

@if (!settings.disableRecipePhotos) {
  <span class="image" [class.no-image]="!recipe.usePhoto || !recipe.photoUrl">
    @if (recipe.usePhoto && recipe.photoUrl && !settings.disableRecipePhotos) {
      <img [src]="photoUrl(recipe)" />
    }
    @if ((!recipe.usePhoto || !recipe.photoUrl) && !settings.disableRecipePhotos) {
      <span>
        Photo
        <br />
        coming
        <br />
        soon...
      </span>
    }
  </span>
}
